import React from 'react';
import { connect } from 'dva';
import { templateConfig, reduxTemplateCofig } from './doneConfig'

import { framework_tool } from '@/tool'
import { modelUtils } from '@/utils';
let { WizContainer, WizReduxTemplate } = framework_tool;
class PorcTaskDone extends WizContainer {

  componentName = 'PorcTaskDone';

  constructor(props) {
    super(props);
    this.state = {
    }
  }

  _handleCMD(nextProps, nextState, key) {
    let o = nextProps[key]
    if (o['success']) {
      wizNotice.success(o['msg'])
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }


  _render() {
    let _reduxTemplateCofig = reduxTemplateCofig({
      templateConfig: templateConfig,
      apiDataFormat: {
      },
    })
    return <WizReduxTemplate {..._reduxTemplateCofig} />
  }
}

const mapStateToProps = (state, ownProps) => {
  const {procTaskDone} = state
  return {
  }
};

export default connect(mapStateToProps)(PorcTaskDone);
